<picture (click)="this.clickElemento.emit(true)"><img [src]="imagen?.src" [alt]="imagen?.alt"></picture>
<div class="slide-cont">
    <ng-container *ngIf="titulo">
        <!-- seleccion tag -->
        <ng-container [ngSwitch]="tamanoTitulo">
            <h1 *ngSwitchCase="'h1'" class="slide-tit">{{titulo}}</h1>
            <h2 *ngSwitchCase="'h2'" class="slide-tit">{{titulo}}</h2>
            <h3 *ngSwitchCase="'h3'" class="slide-tit">{{titulo}}</h3>
            <h4 *ngSwitchCase="'h4'" class="slide-tit">{{titulo}}</h4>
            <h5 *ngSwitchCase="'h5'" class="slide-tit">{{titulo}}</h5>
            <h6 *ngSwitchCase="'h6'" class="slide-tit">{{titulo}}</h6>
            <div *ngSwitchCase="'div'" class="slide-tit">{{titulo}}</div>
            <p *ngSwitchCase="'p'" class="slide-tit">{{titulo}}</p>
            <ng-container *ngSwitchDefault>
                <h1 class="slide-tit">{{titulo}}</h1>
            </ng-container>        
        </ng-container>
    </ng-container>
    <div *ngIf="texto" class="slide-txt">
        <neo-span-inner-html [contenido]="texto"></neo-span-inner-html>
    </div>
    <a *ngIf="enlace" class="btn btn-n1" [href]="enlace" title="">{{boton}}</a>
</div>